// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"c350d42a7312da7c","232":"f535b5f540d6f843","826":"1df2cd4b75f105fe","931":"581692bb40009c88"}[chunkId] + ".css";
};